import styled from 'styled-components';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

export const Title = styled(Typography)`
  ${({
    theme: {
      colors,
      transitions: { easing, duration },
    },
  }) => `
    color: ${colors.blues.blues1};
    font-weight: 500;
    transition: ${duration.standard}ms ${easing.easeInOut};
    flex: 1 1 auto;
    margin-right: 12px;
  `}
`;

export const Icon = styled(Box)`
  ${({
    theme: {
      colors,
      transitions: { easing, duration },
    },
  }) => `
    display: flex;
    justify-content: flex-end; 
    flex: 1 0 auto;

    svg {
      fill: ${colors.greys.greys19};
      transition: ${duration.standard}ms ${easing.easeInOut};
    }
  `}
`;

export const Link = styled(Box)`
  ${({ theme: { colors, palette } }) => `
    border-bottom: 1px solid ${colors.greys.greys5};

    a {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 21px 0;
    }

    &:hover {
      ${Title} {
        color: ${palette.action.hover};
      }

      ${Icon} {
        svg {
          fill: ${palette.action.hover};
        }
      }
    }
  `}
`;
